/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `ACTIVE` - Active
 * * `INACTIVE` - Inactive
 * * `VETERAN` - Veteran
 */
export enum MilitaryStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    VETERAN = 'VETERAN',
}
